import * as yup from "yup";

const logValidationError = (message) => {
  return false; // Returning `false` means the validation failed
};

const acceptanceFormSchema = yup.object().shape({
  sampleReceivedDate: yup
    .date()
    .typeError("Sample Received Date must be a valid date")
    .required("Sample Received Date is required")
    .label("Sample Recieved Date"),
  expectedDateOfCompletion: yup
    .date()
    .typeError("Expected Completion Date must be a valid date")
    .required("Please provide Expected Completion Date")
    .label("Expected Date of Completion")
    .test(
      "is-greater",
      "Expected Date Of Completion Should be after Sample Received Date",
      function (value) {
        const { sampleReceivedDate } = this.parent;
        if (!value || !sampleReceivedDate) return true;
        return new Date(value) >= new Date(sampleReceivedDate);
      }
    ),
  samplePhysicalCondition: yup
    .string()
    .required("Please Select Sample Physical Condition")
    .label("Physical Condition"),
  sampleSealNumber: yup
      .string()
      .required("Please provide values for Sample Seal Number")
      // .matches(/^AG-\d{5}$/, "Sample Seal Number must be in format AG-12345")
      .label("Sample Seal Number"),
  conditionOfSeal: yup
    .string()
    .required("Please Select Condition Of Seal")
    .label("Condition of Seal"),
  additionalSampleNeeded: yup
    .string()
    .required("Please select one for Additional Sample Required")
    .matches(/^(?!\s+$).+/, "Please select one for Additional Sample Required")
    .label("Additional Sample Needed"),
  additionalSampleReasons: yup.string().when("additionalSampleNeeded", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
      .string()
      .required("Please provide reason for Additional Sample")
      .matches(/^(?!\s+$).+/, "Please provide reason for Additional Sample")
      .label("Reason For Additional Sample")
      .test(
        "log-error",
        "Please provide reason for Additional Sample",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError(
              "Additional Sample Reasons is invalid or missing"
            );
            return false;
          }
          return true;
        }
      ),
    otherwise: yup.string(),
  }),
  sampleRegistrationNumber: yup
    .string()
    .required("Please provide Sample Registration Number")
    .matches(
      /^[a-zA-Z0-9\s]+$/,
      "Special characters are not allowed in Sample Registration Number"
    )
    .label("Sample Registration Number")
    .test(
      "log-error",
      "Please provide Sample Registration Number",
      function (value) {
        if (!value || /^\s*$/.test(value)) {
          logValidationError(
            "Sample Registration Number is invalid or missing"
          );
          return false;
        }
        return true;
      }
    ),
});

export default acceptanceFormSchema;
